module.exports = __webpack_public_path__ + "img/surepay.6eebd865.png";